import React, { createContext, useContext } from 'react'
import useDropDown from './useDropDown'
import styles from './Dropdown.module.css'

const context = createContext({})

export default function Dropdown(props) {
  const ctx = useDropDown()

  return (
    <context.Provider value={ctx}>
      <div
        {...props}
        className={[
          props.className,
          'relative',
        ]}
      />
    </context.Provider>
  )
}

export function DropdownToggle(props) {
  const {
    as: Type = 'button',
    children,
    onClick,
    className,
    toggledClassName,
    ...rest
  } = props

  const { setOpen, isOpen } = useContext(context)

  const handleClick = event => {
    if (onClick) {
      onClick(event, setOpen)
    }
    if (!event.defaultPrevented) {
      setOpen(o => !o)
    }
  }

  let element = children
  if (typeof element === 'function') {
    element = element({ isOpen: ctx.isOpen })
  }

  return (
    <Type
      {...rest}
      onClick={handleClick}
      children={element}
      className={[
        props.className,
        isOpen && toggledClassName,
      ]}
    />
  )
}

export function DropdownContent(props) {
  const ctx = useContext(context)

  let content = props.children
  if (typeof content === 'function') {
    content = content(ctx)
  }

  return (
    <div
      ref={ctx.ref}
      {...props}
      children={content}
      className={[
        props.className,
        styles.content,
        ctx.isOpen && styles.open,
        'absolute z-10 whitespace-no-wrap overflow-auto',
      ]}
    />
  )
}

export function DropdownItem(props) {
  const {
    as: Type = 'button',
    onClick,
    ...rest
  } = props

  const { setOpen } = useContext(context)

  const handleClick = event => {
    if (onClick) {
      onClick(event, setOpen)
    }
    if (!event.defaultPrevented) {
      setOpen(o => !o)
    }
  }

  return (
    <Type
      {...rest}
      onClick={handleClick}
    />
  )
}

Dropdown.Toggle = DropdownToggle
Dropdown.Content = DropdownContent
Dropdown.Item = DropdownItem
